// extracted by mini-css-extract-plugin
export var modal = "_gb-0";